import React from 'react';
import {
  Globe, TrendingUp, Users, Search, Handshake, Landmark, Trophy,
  UserRound, Sprout, Target, Cpu, Dices, Building2, Music,
  Phone, Mail, MapPin, FileText, Menu, X, ChevronRight, ChevronDown,
  ArrowRight, CheckCircle2, Send, Monitor,
  Martini, Mic, FerrisWheel, Home, BarChart3, Cog, Lightbulb, Gem, Spade, WalletCards,
} from 'lucide-react';

const MAP = {
  Globe, TrendingUp, Users, Search, Handshake, Landmark, Trophy,
  UserRound, Sprout, Target, Cpu, Dices, Building2, Music,
  Phone, Mail, MapPin, FileText, Menu, X, ChevronRight, ChevronDown,
  ArrowRight, CheckCircle2, Send, Monitor,
  Martini, Mic, FerrisWheel, Home, BarChart3, Cog, Lightbulb, Gem, Spade, WalletCards,
};

const Icon = ({ name, ...props }) => {
  const Cmp = MAP[name] || Globe;
  return <Cmp {...props} />;
};

export default Icon;
